import { iots } from '@code-expert/prelude';
import { LtiSessionId, ProjectId, SubmissionId, TaskId, UserId } from '/imports/domain/identity';
import type { Request } from '/imports/utils/http';

const LtiRequest = iots.strict({
  url: iots.string,
  method: iots.literal('POST'),
  body: iots.string,
  headers: iots.record(iots.string, iots.string),
}) satisfies iots.Type<Request, unknown>;

const LtiResponse = iots.strict({
  url: iots.string,
  headers: iots.record(iots.string, iots.union([iots.string, iots.array(iots.string)])),
  body: iots.string,
});

export type LtiResponse = iots.TypeOf<typeof LtiResponse>;

const LtiResultData = iots.union([
  iots.strict({ response: LtiResponse }),
  iots.strict({ error: iots.string }),
]);

export type LtiResultData = iots.TypeOf<typeof LtiResultData>;

const LtiResult = iots.intersection([
  iots.strict({ date: iots.date, request: LtiRequest }),
  LtiResultData,
]);

export type LtiResult = iots.TypeOf<typeof LtiResult>;

export const LtiSessionC = iots.struct(
  {
    _id: LtiSessionId,
    userId: UserId,
    taskId: TaskId,
    date: iots.date,
    ltiRequest: iots.unknown,
    sent: iots.boolean,
    ltiResults: iots.array(LtiResult),
    cxLtiVersion: iots.number,
    locked: iots.boolean,
  },
  {
    projectId: ProjectId,
    submissionId: SubmissionId,
    resumedSessionId: LtiSessionId,
    basedOnLastSessionId: LtiSessionId,
    /** used when starting a new LTI session based on last (cx-719) */
    basedOnLastSubmissionId: SubmissionId,
  },
);

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface LtiSession extends LtiSessionType {}

type LtiSessionType = iots.TypeOf<typeof LtiSessionC>;
